export const messages = {
  suggestions: '建议箱',
  improvements: '改进记录',
  timer: '番茄钟',
  add: '添加',
  pending: '待定',
  adopted: '采纳',
  rejected: '拒绝',
  empty: '暂无',
  start: '开始',
  pause: '暂停',
  reset: '重置',
  sessions: '今日完成',
  minutes: '分钟'
} as const
